import paymentTpye from '../type/payment-type-order.type'

export default [
  {
    title: paymentTpye.cash.title,
    value: paymentTpye.cash.value,
  },
  {
    title: paymentTpye.bill.title,
    value: paymentTpye.bill.value,
  },
  {
    title: paymentTpye.onlineCard.title,
    value: paymentTpye.onlineCard.value,
  },
  {
    title: paymentTpye.shopCard.title,
    value: paymentTpye.shopCard.value,
  }
]